// extracted by mini-css-extract-plugin
export default {"disabledWrapper":"AppyPricesButton_disabledWrapper__UiViV"};